import { useEffect } from 'react'
import faqs from './data'
import FAQ from './FAQ'
import AOS from 'aos'
import 'aos/dist/aos.css'
import './faqs.css'

const FAQs = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 })
  })

  return (
    <section id="faqs">
      <h2>Preguntas Frecuentes</h2>
      <p>
        ¡Encuentre a continuación las respuestas a las preguntas más frecuentes! Si tiene alguna otra consulta, no dude en ponerse en contacto conmigo.
      </p>
      <div className="container faqs__container" data-aos="fade-in">
        {
          faqs.map(faq => (
            <FAQ key={faq.id} faq={faq} />
          ))
        }
      </div>
    </section>
  )
}

export default FAQs